import graphqlClient from "./graphqlClient";
import {ALLOWED_SPORTS, GAME_MEDIA} from "./graphql/sporty-queries";
import {CREATE_CUSTOM_CLIP} from "./graphql/sporty-mutations";

export default class SportyGateway {
  getGameMedia(gamePk, gameDate) {
    return graphqlClient
      .query({ variables: { gamePk, gameDate }, query: GAME_MEDIA })
      .then(response => response.data && response.data.gameMedia);
  }

  createCustomClip(customClipInput) {
    return graphqlClient
    .mutate({
      variables: {customClipRequest: customClipInput},
      mutation: CREATE_CUSTOM_CLIP
    })
    .then(r => r.data && r.data.createCustomClip);
  }

  getAllowedSports() {
    return graphqlClient
    .query({query: ALLOWED_SPORTS})
    .then(r => r.data && r.data.allowedSports);
  }
}



// WEBPACK FOOTER //
// ./src/httpClients/SportyGateway.js